import * as Yup from 'yup';

import type { FileProps } from '@/context/FileContext/types';

export const validation = Yup.object().shape({
  damageType: Yup.string().required('Selecione o tipo de problema'),
  resolution: Yup.string().required('Selecione o que precisa ser feito'),
  quotationLink: Yup.string()
    .nullable()
    .test('link-or-file', 'Forneça um link OU faça upload do orçamento/NF', function () {
      // A validação de obrigatoriedade será feita no submit do componente
      // pois quotationFile está no contexto, não no Formik
      // Este teste apenas garante que se houver link, ele seja válido
      return true;
    })
    .test(
      'url-format',
      'URL inválida. Deve ser uma URL completa (ex: https://exemplo.com)',
      (value) => {
        if (!value || value.trim() === '') return true;

        const trimmedValue = value.trim();

        if (!/^https?:\/\//i.test(trimmedValue)) return false;

        const urlPattern =
          /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{2,}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;

        return urlPattern.test(trimmedValue);
      },
    ),

  items: Yup.array()
    .of(
      Yup.object().shape({
        description: Yup.string().required('Descreva o ocorrido'),
        itemName: Yup.string().required('Nome do item obrigatório'),
        itemPrice: Yup.string().required('Valor obrigatório'),
        quantity: Yup.number().min(1, 'Mínimo 1').required(),
        evidenceFiles: Yup.array()
          .of(Yup.mixed<FileProps>())
          .min(1, 'Faça o upload de pelo menos uma foto/arquivo')
          .required('Faça o upload de pelo menos uma foto/arquivo'),
      }),
    )
    .min(1, 'Adicione pelo menos um item na tabela'),
});
